import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Col, Button, Row, Alert, ListGroup, ListGroupItem } from 'react-bootstrap';
import { IListItem, IDonorRegistration, IDonorStatus } from '@nkr/models/index'; //this is for loading of the initial data to page
import { DonorIntakeAction } from '../donor-intake-action';
import { ICoordinator } from '../../coordinator';
import { FormWrapper } from './styles';
import { DashRegistrationStep, AlternateDonationOptions } from '@nkr/enums/index'; //this is for loading of the initial data to page
import { IDashRemoteStatus } from '@nkr/models/donor-status-by-center';
import { IDashWorkFlowStatusRequest } from '@nkr/models/dash-workflow-status-request';
import { cardBodyStyle, cardBodyTitleStyle, cardStyle, cardBodyTitleTextStyle } from '../../styles';
import ActionsDropdown from '../actions-dropdown';
import PreScreening from './pre-screening';
import HistoryMisc from './history-misc';
import MedicalHistory from './medical-history';
import LivingDonorFamilyMedicalHistory from './living-donor-family-medical-history';
import SocialHistory from './social-history';
import IdentityInformation from './identity-information';
import Details from './details';
import DashStatusForm from '../status-form';
import MicrositeInfo from './microsite-Info';
import RegistrationInfo from './registration-info';
import DonatingForInfo from './donating-for-info';
import DonorMentorInfo from './donor-mentor-info';
import LostWageReimbursementInfo from './lost-wage-reimbursement-info';

interface IProps {
    data: IDonorRegistration,
    lookUpData: {
        emailTemplate: string,
        statusListForCenter: IDonorStatus[],
        remoteStatusList: IDashRemoteStatus[],
        actionList: IListItem[],
        donationTypeList: IListItem[],
        dispositionList: IListItem[],
        coordinatorListForCenter: ICoordinator[],
        ruleOutReasons: IListItem[]
    },
    onDataChange: (field: string, value: any) => void,
    onUpdate: (request: IDashWorkFlowStatusRequest) => void,
    onSaveCenterCard?: () => void | Promise<void>,
    onSaveNetworkCard?: () => void | Promise<void>,
    statusFormBaselineKey?: number,
    onItemSelected: (id: number, action: number) => void,
    onRuleOut?: (donorId: number, reasonId: number, allowReRegistration: boolean, useNkrAssistance: boolean, coordinatorName?: string, phoneNumber?: string, medicalReasonCategory?: number, medicalReasonNotes?: string) => void
}

export const AlternateDonationOptionsDescriptions: Record<AlternateDonationOptions, string> = {
    [AlternateDonationOptions.KidneyPairedDonation]: "Paired Donation",
    [AlternateDonationOptions.AdvancedDonation]: "Voucher Donation",
    [AlternateDonationOptions.GoodSamaritanDonation]: "Non-Directed Donation",
    [AlternateDonationOptions.FindSomeoneElse]: "Finding Someone Else",
    [AlternateDonationOptions.FamilyVoucher]: "FV Donation"
};

const Content = (props: IProps) => {
    const microsite = props.data.micrositeRecipient;

    let url = window.location.pathname;

    return (
        <div className='container-fluid' style={{ paddingBottom: 10 }}>
            <FormWrapper>
                <Row>
                    <Col xs={12} lg={2} style={{ position: 'sticky', top: 0 }}>
                        <h4>Donor Intake Details</h4>
                        <ListGroup>
                            <ListGroupItem href={url + '#living-donor-details'}>Living Donor Details</ListGroupItem>
                            <ListGroupItem href={url + '#registration-info'}>Registration information</ListGroupItem>
                            <ListGroupItem href={url + '#donor-details'}>Donor Details</ListGroupItem>
                            <ListGroupItem href={url + '#pre-screening'}>Living Donor Pre-Screening</ListGroupItem>
                            <ListGroupItem href={url + '#history-misc'}>History Misc</ListGroupItem>
                            <ListGroupItem href={url + '#medical-history'}>Medical History</ListGroupItem>
                            <ListGroupItem href={url + '#living-donor-family-medical-history'}>Family Medical History</ListGroupItem>
                            <ListGroupItem href={url + '#social-history'}>Social History</ListGroupItem>
                        </ListGroup>
                    </Col>
                    <Col xs={12} lg={10}>
                        <Row className='row-margined' style={{ marginBottom: 20 }}>
                            <Col xs={12} sm={6}>
                                <Button bsStyle='success' disabled={false} onClick={() => props.onItemSelected(props.data.id, DonorIntakeAction.GetPdf)}>Download PDF</Button>
                            </Col>

                            <Col xs={12} sm={6} style={{ textAlign: 'right' }}>
                                {props.data.currentRegistrationStep != DashRegistrationStep.Transferred && (
                                    <ActionsDropdown
                                        donor={props.data}
                                        showLinkToDetails={false}
                                        showBsMenu={true}
                                        onMenuToggle={() => null}
                                        onItemSelected={props.onItemSelected}
                                        isSuperAdmin={false}
                                    />
                                )}
                            </Col>
                        </Row>

                        {props.data.isOnHold && (
                            <Alert bsStyle='warning'>
                                <strong>ON HOLD:</strong> {props.data.onHoldReason}
                            </Alert>
                        )}

                        {props.data.isReadOnly && (
                            <Alert bsStyle='warning'>
                                <strong>READ ONLY:</strong> This donor is visible through your DASH domain, but workflow updates and donor edits are disabled.
                            </Alert>
                        )}

                        {props.data.isClosed && (
                            <Alert bsStyle='danger'>
                                <strong>COMPLETED:</strong> This donor profile was completed/closed on {moment(props.data.closedDateTime).format('M/D/YYYY')} by {props.data.closedByUsername}
                            </Alert>
                        )}

                        {props.data.currentRegistrationStep >= DashRegistrationStep.AutoRuledOut && props.data.ruleOutReasons && (
                            <Alert bsStyle='danger'>
                                <strong>RULED OUT REASON:</strong> {props.data.ruleOutReasons.replace(/\byou\b/g, 'they').replace(/\byour\b/g, '[their]')}
                            </Alert>
                        )}

                        {props.data.isRemoteDonationPreferred && props.data.remoteCenterId !== props.data.centerId && (
                            <Alert bsStyle='info'>
                                This potential donor has indicated that they wish to donate for their recipient remotely{props.data.isHardshipToTravel ? ', and that it would be a hardship to travel to your center.' : '.'} They have indicated that they wish to donate at <span className='label label-default'>{props.data.recipientCenterAlias}</span>. Please identify the best method of transferring to the remote center, converting to a local donor, or ruling out the donor if no options are viable. Then, select the chosen option from the actions dropdown.
                                <br />
                                <br />
                                <span className='label label-warning'>NOTE: Select the Transfer Method from the Actions dropdown to see additional details before finalizing.</span>
                            </Alert>
                        )}

                        <div id='living-donor-details' style={cardStyle}>
                            <div style={cardBodyStyle}>
                                <div style={cardBodyTitleStyle}>
                                    <span style={cardBodyTitleTextStyle}>Living Donor Details</span>
                                </div>

                                <DashStatusForm
                                    key={'status-form-' + props.data.id + '-' + (props.statusFormBaselineKey || 0)}
                                    data={props.data}
                                    statusList={props.lookUpData.statusListForCenter}
                                    remoteStatusList={props.lookUpData.remoteStatusList}
                                    coList={props.lookUpData.coordinatorListForCenter}
                                    onUpdate={props.onUpdate}
                                    onSaveCenterCard={props.onSaveCenterCard}
                                    onSaveNetworkCard={props.onSaveNetworkCard}
                                    onDataChange={props.onDataChange}
                                    useWideFormat={true}
                                    ruleOutReasons={props.lookUpData.ruleOutReasons}
                                    onRuleOut={props.onRuleOut}
                                    isReadOnly={props.data.isReadOnly}
                                />
                            </div>
                        </div>

                        {props.data.remoteTransferType && (
                            props.data.remoteTransferType !== 'Local Donor' ? (
                                props.data.remoteTransferType == 'Not A Valid Recipient' ? (
                                    <Alert bsStyle='info'>
                                        <div style={{ marginBottom: '10px' }}>
                                            This donor registered as a remote donor for a {props.data.recipientCenterAlias} recipient.
                                                However, this patient is not at {props.data.recipientCenterAlias}, and as the donor candidate's preferred center, we have transferred them to you.
                                            </div>
                                    </Alert>

                                ) : (
                                    <Alert bsStyle='info'>
                                        <div style={{ marginBottom: '10px' }}>
                                            This is a donor that would prefer to donate close to home for a recipient at {props.data.recipientCenterName}. {props.data.recipientCenterName} has transferred this donor to your center as <span className='label label-default'>{props.data.remoteTransferType}</span>.
                                            </div>
                                    </Alert>
                                )
                            ) : (
                                <Alert bsStyle='info'>
                                    <div>
                                        This donor was originally set to donate at <span style={{ fontWeight: 'bold' }}>{props.data.recipientCenterAlias}(get original center)</span> but was converted to a 'local' donor.
                                        </div>
                                </Alert>
                            )
                        )}

                        <RegistrationInfo data={props.data} />

                        {microsite && (
                            <MicrositeInfo data={props.data} microsite={microsite} />
                        )}

                        {!microsite && (props.data.type == 'SV' || props.data.type == 'DD') && (
                            <DonatingForInfo data={props.data} />
                        )}

                        {(props.data.ssn || props.data.passportNum || (props.data.dlNumber && !props.data.passportNum)) && (
                            <IdentityInformation data={props.data} />
                        )}

                        <Row>
                            <Col xs={12} lg={6}>
                                {props.data.connectToDonorAcceptedDate && (
                                    <DonorMentorInfo data={props.data} />
                                )}
                            </Col>

                            <Col xs={12} lg={6}>
                                {props.data.wantsWageReimbursement && (
                                    <LostWageReimbursementInfo data={props.data} />
                                )}
                            </Col>
                        </Row>

                        <Details data={props.data} />

                        <Row>
                            <Col xs={12} lg={6}>
                                <PreScreening data={props.data} />
                            </Col>

                            <Col xs={12} lg={6}>
                                <HistoryMisc data={props.data} />
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={6}>
                                <MedicalHistory data={props.data} />
                            </Col>

                            <Col xs={12} lg={6}>
                                <LivingDonorFamilyMedicalHistory data={props.data} />
                            {/* </Col>
                        </Row>

                        <Row>
                            <Col xs={12} lg={6}> */}
                                <SocialHistory data={props.data} />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </FormWrapper>
        </div>
    );
    // }
}

export default Content;

